import Container from '@/components/Container';
import Link from '@/components/Link';
import HeaderSub from '@/view/HeaderSub';
import Partner from '@/domain/Partners/PartnerListing';
import client from '@/api/client';
import { partnerListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: partnerListingQuery });

  return {
    props: {
      partners: data?.partners?.nodes || [],
    }
  }
}

export default function Partners({
  partners,
}) {
  return (
    <div className="bg-white">
      <HeaderSub
        pageTitle={(
          <Link className="text-green-500" href="/socios">
            Nuestros socios y colaboradores
          </Link>
        )}
        menu={[
          {
            title: 'Listado de socios',
            url: '/socios',
          },
          {
            title: 'Únete al programa',
            url: '/programa-de-socios',
            useArrow: true,
          }
        ]}      
      />
      <div className="pt-10 lg:pt-16">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="lg:col-span-8 lg:col-start-3 text-center">
              <h1 className="text-4xl lg:text-5xl font-bold tracking-tight">
                Alianzas duraderas para liderar la&nbsp;
                <div className="text-green-500">transformación ágil</div>
              </h1>
            </div>
          </div>
        </Container>
      </div>
      <div className="relative z-100">
        <div className="py-10 lg:py-20">
          <Container className="space-y-10 lg:space-y-12">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
              {partners.map(({ id, ...partner }) => (
                <div key={`partner-${id}`} className="lg:col-span-6 flex">
                  <Partner key={id} {...partner} />
                </div>
              ))}
            </div>
          </Container>
        </div>
        <div className="py-10 lg:py-12 bg-gray-100">
          <Container>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
              <Link href="/entrenadores" className="flex flex-col md:flex-row md:items-center shadow-lg hover:shadow-2xl transition ease-in-out duration-500 transform rounded-xl lg:col-span-6 relative overflow-hidden space-x-8 bg-white p-8 pl-28">
                <div className="absolute left-0 top-0 bottom-0 flex items-center -ml-5">
                  <svg className="w-40 h-40 relative z-10 -ml-4" width="48" height="48" viewBox="0 0 48 48">
                    <path className="fill-current text-green-200" d="M8,41l5.818-10.889L18.182,28.3l2.909-5.445h5.818L29.818,28.3l4.364,1.815L40,41H8Z" />
                    <path className="fill-current text-green-500" d="M32,17l-1,3H30l-1,3-4,3H23l-4-3-1-3H17l-1-3h2l-1-6,7-4,7,4-1,6h2Z" />
                  </svg>
                  <div className="absolute left-0 top-0 bottom-0 w-2/3 bg-gradient-to-b from-green-100 to-white z-0" />
                </div>
                <div className="flex-1 space-y-4">
                  <h2 className="flex items-center space-x-3">
                    <div className="text-xl font-semibold">
                      Encuentra un entrenador
                    </div>
                  </h2>
                  <h3 className="text-base text-gray-500 font-normal">
                    Están preparados para enseñar y acompañar a los equipos en el dominio de
                    las técnicas y herramientas que los conducirán el desarrollo ágil de productos.
                  </h3>
                </div>
              </Link>
              <Link href="/programa-de-socios" className="flex flex-col md:flex-row md:items-center shadow-lg hover:shadow-2xl transition ease-in-out duration-500 transform rounded-xl lg:col-span-6 relative overflow-hidden space-x-8 bg-white p-8 pl-28">
                <div className="absolute left-0 top-0 bottom-0 flex items-center -ml-5">
                  <svg className="w-32 h-32 relative z-10" viewBox="0 0 48 48">
                    <path className="fill-current text-green-200" d="M29.624,43.785L25.381,32.472l7.778-7.778,2.075,8.735ZM4.168,18.329l10.357-5.611,8.735,2.075-7.778,7.778ZM5.624,34.991c1.92-4.929,5.24-2.274,5.24-2.274l2.222,2.217,2.2,2.193s2.627,3.28-2.295,5.213a12.725,12.725,0,0,1-4.578.376c-0.815-.076-3.537,1.6-4.347,1.222-0.39-.814,1.288-3.537,1.207-4.355A12.681,12.681,0,0,1,5.624,34.991Z" />
                    <path className="fill-current text-green-500" d="M10.7,24.537C29.323,6.122,43.983,3.986,43.983,3.986S41.823,18.484,23.2,36.9c0,0-4.841,5.327-11.38-1.14A8.244,8.244,0,0,1,10.7,24.537Z" />
                    <path className="fill-current text-green-200" d="M27.646,20.336a4.454,4.454,0,1,1-6.346-.058A4.512,4.512,0,0,1,27.646,20.336Z" />
                  </svg>
                  <div className="absolute left-0 top-0 bottom-0 w-2/3 bg-gradient-to-b from-green-100 to-white z-0" />
                </div>
                <div className="flex-1 space-y-4 lg:-ml-10">
                  <h2 className="flex items-center space-x-3">
                    <div className="text-xl font-semibold">
                      Únete al programa de socios
                    </div>
                  </h2>
                  <h3 className="text-base text-gray-500 font-normal lg:pr-20">
                    Trabajemos juntos para tener un mayor impacto en la adopción de la cultura ágil.
                  </h3>
                </div>
              </Link>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
}

